(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-address"] && !Shopify.designMode) return;
  try {
    
  // window.addEventListener('load', () => {
  //   typeof CustomerAddresses !== 'undefined' && new CustomerAddresses();
    
  // });

    // Edit Modal Control
  window.openEditModal = function(id) {
    const modal = document.getElementById(`EditAddressModal_${id}`);
    modal.style.display = 'flex';

    // 添加一次性的点击监听器（避免重复绑定）
    const handler = function(e) {
      if (e.target === modal) {
        modal.style.display = 'none';
        modal.removeEventListener('click', handler); // 解绑监听器
      }
    };

    modal.addEventListener('click', handler);
  };

  window.closeEditModal = function(id) {
    document.getElementById(`EditAddressModal_${id}`).style.display = 'none';
  };

  document.addEventListener('DOMContentLoaded', function () {
    // swiper
    var addressSwiper = new Swiper('.address-swiper', {
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: '.address-next',
        prevEl: '.address-prev',
      },
      breakpoints: { 
        1200: { // 当swiper宽度大于等于1200
          slidesPerView: 4,
          spaceBetween: 20
        },
        1000: { // 当swiper宽度大于等于1000
          slidesPerView: 3,
          spaceBetween: 16
        },
        768: { // 当swiper宽度大于等于768
          slidesPerView: 2,
          spaceBetween: 16
        },
      }
    })

    // 初始化国家 省份选择器
    document.querySelectorAll('select[data-address-country-select]').forEach(countrySelect => {
      const formId = countrySelect.dataset.formId;

      new Shopify.CountryProvinceSelector(
        `AddressCountry_${formId}`,
        `AddressProvince_${formId}`,
        { hideElement: `AddressProvinceContainer_${formId}` }
      );
    });

    const newCountry = document.getElementById('AddressCountryNew');
    const newProvince = document.getElementById('AddressProvinceNew');
    if (newCountry && newProvince) {
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        { hideElement: 'AddressProvinceContainerNew' }
      );
    }

    // 拦截add表单 添加地址后刷新页面
    const form = document.querySelector('#address_form_new');

    form.addEventListener('submit', async (e) => {
      e.preventDefault(); // 阻止默认跳转

      const formData = new FormData(form);

      try {
        const response = await fetch(form.action, {
          method: form.method,
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (response.ok) {
          // 提交成功后刷新当前页面
          window.location.reload();
        } 
      } catch (error) {
        console.error('Error：' + error.message);
      }
    });

    // 绑定edit删除事件
    document.querySelector('[data-customer-addresses]').addEventListener('click', async function (e) {
      const deleteBtn = e.target.closest('button[data-confirm-message]');
      if (!deleteBtn) return;

      if (!confirm(deleteBtn.getAttribute('data-confirm-message'))) return;

      e.preventDefault();

      try {
        const response = await fetch(deleteBtn.dataset.target, {
          method: 'POST',  // Shopify 删除接口用 POST + _method=delete
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: '_method=delete'
        });

        if (response.ok) {
          // 删除成功，刷新当前页面
          window.location.reload();
        }
      } catch (error) {
        console.error('Error occurred: ' + error.message);
      }
    });


    
  // Add Address Modal
  const openBtn = document.querySelector('.add-btn');
  const modal = document.getElementById('AddAddressModal');
  const dismissBtn = document.querySelector('.add-address-dismiss');
  const cancelBtn = modal.querySelector('.btn-cancel');
  const modalContent = modal.querySelector('.modal-content');

  modal.querySelector('.modal-content').addEventListener('click', (e) => {
    e.stopPropagation(); // 防止触发 modal 的点击事件
  });

  modal.addEventListener('click', ()=> {
    modal.classList.add('hide');
    openBtn.ariaExpanded = false
  })

  dismissBtn.addEventListener('click', ()=> {
    modal.classList.add('hide');
    openBtn.ariaExpanded = false
  })

  openBtn.addEventListener('click', () => {
    modal.classList.remove('hide');
  });


  cancelBtn.addEventListener('click', (e) => {
    modal.classList.add('hide');
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["account-order"] && !Shopify.designMode) return;
  try {
    
  window.copyOrder = function(button, order) {
    if (!order) return;

    navigator.clipboard.writeText(order.toString())
      .then(() => {
        // 修改按钮文本
        const originalText = button.innerText;
        button.innerText = "Copied!";

        // 3秒后恢复原文本
        setTimeout(() => {
          button.innerText = originalText;
        }, 3000);
      })
      .catch((err) => {
        console.error("Failed to copy order:", err);
      });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.createDisplayObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.displayObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }
    createDisplayObserver(){
      this.displayObserver = new MutationObserver(() => {
        this.checkAnnouncementBarVisibility();
      });

      this.displayObserver.observe(this.announcementBar, { attributes: true, attributeFilter: ['style'] });
    }
    checkAnnouncementBarVisibility() {
      let displayStyle = window.getComputedStyle(this.announcementBar).getPropertyValue('display');

      if (displayStyle === 'none') {
          this.createObserver();
      }
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      // this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
     
  // 如果没有 active 的 span，给第一个 span 添加 active
  const container = document.querySelector(".blog-menu-content");
  const active = container.querySelector(".active");
  if (!active) {
    const firstSpan = container.querySelector("span");
    if (firstSpan) {
      firstSpan.classList.add("active");
    }
  }

  // 显示当前标签的标题
  const activeSpan = document.querySelector(".blog-menu-content .active");
  if (activeSpan) {
    let tagText = activeSpan.textContent.trim();
    document.querySelector(".active-title").textContent = tagText;
  }



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["work-in-progress"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var mySwiper = new Swiper('.coupon-swiper', {
      slidesPerView: 1.5,
      spaceBetween: 16,
      navigation: {
        nextEl: '.coupon-next',
        prevEl: '.coupon-prev',
      },
      breakpoints: { 
        1440: { // 当swiper宽度大于等于1440
          slidesPerView: 6,
          spaceBetween: 16
        },
        1200: { // 当swiper宽度大于等于1200
          slidesPerView: 5,
          spaceBetween: 16
        },
        1000: { // 当swiper宽度大于等于1000
          slidesPerView: 4,
          spaceBetween: 16
        },
        768: { // 当swiper宽度大于等于768
          slidesPerView: 3,
          spaceBetween: 16
        },
        500: { // 当swiper宽度大于等于500
          slidesPerView: 2,
          spaceBetween: 16
        },
      }
    });

    // 监听smile是否已经加载
    document.addEventListener('smile-ui-loaded', () => {
      console.log("Smile UI Loaded");
      Smile.fetchCustomer({ include: 'vip_tier' }).then((customer) => {

        const vipName = customer.vip_tier?.name || 'Unknown';
        const points = customer.points_balance ?? '0';

        console.log("smile data:", customer);
        // 更新用户等级
        document.querySelectorAll(".tier strong").forEach(el => {
          el.innerHTML = vipName;
        });
        // 更新用户分数
        document.querySelectorAll(".balance").forEach(el => {
          el.innerHTML = points;
        });

        // coupon 处理
        document.querySelectorAll('.coupon').forEach(coupon => {
          const pointRequirement = parseInt(
            coupon.querySelector('.point').dataset.point,
            10
          );
          
          const redeemBtn = coupon.querySelector('.redeem');
          const keepEarningBtn = coupon.querySelector('.keep-earning');

          if (points >= pointRequirement) {
            redeemBtn.style.display = 'inline-block';
            keepEarningBtn.style.display = 'none';
          } else {
            redeemBtn.style.display = 'none';
            keepEarningBtn.style.display = 'inline-block';
          }
        });

        function updateMedal(tier) {
          const tierLower = tier.toLowerCase();

          // 根据等级显示对应的彩色图标
          if (tierLower.includes('silver')) {
            document.querySelector('.medal-1 .medal-silver').style.display = 'block';
            document.querySelector('.medal-1 .gray').style.display = 'none';
          }else if (tierLower.includes('gold')) {
            document.querySelector('.medal-2 .medal-gold').style.display = 'block';
            document.querySelector('.medal-2 .gray').style.display = 'none';
          }else {
            document.querySelector('.medal-3 .medal-platinum').style.display = 'block';
            document.querySelector('.medal-3 .gray').style.display = 'none';
          }
        }
        updateMedal(vipName);


        // 添加点击事件
        const redeemBtns = document.querySelectorAll('.show-reward');
        redeemBtns.forEach(btn => {
          btn.addEventListener('click', () => {
            if (window.SmileUI) {
              SmileUI.openPanel();
            } else {
              console.warn('SmileUI 未加载');
            }
          });
        });

      }).catch((err) => {
        console.error('Error fetching Smile customer:', err);
      });
    });
  })

  } catch(e) { console.error(e); }
})();
})();
